module.exports = __webpack_public_path__ + "img/game_main_pc_243_off.fee23c47.png";